import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, ready, homePath } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[#4B5563]" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homePath()} replace />;
  return children;
}
